// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dKlBq","title":"styles_title__2wCeW"};